import type { ReactElement } from 'react';

import styles from './ServerChip.module.css';
import { useLongPress } from './useLongPress';

/**
 * Перенос `_ServerChip` из `base_url_page.dart`.
 *
 * Сервер в выпадающем списке. Long-press удаляет запомненный;
 * на предустановленных удаление не вешается.
 */
export interface ServerChipProps {
  readonly root: string;
  readonly removable: boolean;
  readonly onTap: () => void;
  readonly onRemove: () => void;
}

export function ServerChip({
  root,
  removable,
  onTap,
  onRemove,
}: ServerChipProps): ReactElement {
  // `onLongPress: removable ? onRemove : null`
  const handlers = useLongPress({ onTap, onLongPress: removable ? onRemove : null });

  return (
    <button
      type="button"
      data-testid={`known-server-${root}`}
      className={styles.chip}
      {...handlers}
    >
      <span className={styles.label}>{root}</span>
    </button>
  );
}
